import { Grid } from "@mui/material";
import { FastField, Field } from "formik";
import {
  MyMultiSelect,
  MySelect,
  MyTextField
} from "../../Lib/componentLibrarys";
import { useState } from "react";

export const FormNhapUpdate = ({
  values,
  errors,
  setFieldValue,
  chucVuList,
  phongBanList,
  coQuanQuanLyList,
  rolesByCapList,
  doanhNghiepList,
  coSoSanXuatList,
  coSoCheBienList,
  coSoPhanPhoiList
}) => {
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={6}>
          <FastField name="userName">
            {({ field }) => (
              <MyTextField
                disabled
                required
                label="Tài khoản:"
                placeholder="Nhập..."
                errors={errors?.userName}
                helperText={errors?.userName}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="fullName">
            {({ field }) => (
              <MyTextField
                required
                label="Họ tên:"
                placeholder="Nhập..."
                errors={errors?.fullName}
                helperText={errors?.fullName}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="email">
            {({ field }) => (
              <MyTextField
                required
                label="Email:"
                placeholder="Nhập..."
                errors={errors?.email}
                helperText={errors?.email}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="mobile">
            {({ field }) => (
              <MyTextField
                label="Điện thoại:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="address">
            {({ field }) => (
              <MyTextField label="Địa chỉ:" placeholder="Nhập..." {...field} />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Cơ quan quản lý:"
            placeholder="Chọn..."
            value={values?.coQuanQuanLy}
            options={coQuanQuanLyList || []}
            name="ten"
            onChange={(event, value) => {
              setFieldValue(`coQuanQuanLy`, value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Phòng ban:"
            placeholder="Chọn..."
            value={values?.phongBan}
            options={phongBanList || []}
            name="ten"
            onChange={(event, value) => {
              setFieldValue(`phongBan`, value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Chức vụ:"
            placeholder="Chọn..."
            value={values?.chucVu}
            options={chucVuList || []}
            name="ten"
            onChange={(event, value) => {
              setFieldValue(`chucVu`, value);
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
};
